import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useUser } from '~/api/user';

import type { ForumTag } from './types';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { forumPostSchema } from './schemas';
import { forumPostQueryOptions } from './useForumPost';

type Payload = {
  content: string;
  forumTag: ForumTag;
  title: string;
};

export const useCreateForumPost = () => {
  const { data: user } = useUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: Payload) => {
      const { data: post } = await fetchJson('/forum/posts', {
        method: 'POST',
        schema: apiResourceSchema(forumPostSchema),
        body,
      });

      return post;
    },
    onSuccess: (post) => {
      queryClient.setQueryData(forumPostQueryOptions(post.id).queryKey, post);
      queryClient.invalidateQueries({ queryKey: QueryKeys.forum.index.tag(null) });
      queryClient.invalidateQueries({ queryKey: QueryKeys.forum.index.tag(post.tag) });
      queryClient.invalidateQueries({ queryKey: QueryKeys.forum.index.user(user.id) });
    },
  });
};
